import React from 'react';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
class DeleteIconButton extends React.Component {
  render() {
    const { className, ariaLabel, handleClick } = this.props;

    return (
      <IconButton
        aria-label={ariaLabel ? ariaLabel : 'Delete'}
        color="primary"
        className={className}
        onClick={handleClick}
        size="large">
        <DeleteIcon />
      </IconButton>
    );
  }
}

export default DeleteIconButton;
